<template>
  <tr>
    <td class="middle">{{ index + 1 }}.</td>

    <w-table-cell :model="item.helpDate">
      <w-datepicker :model="item.helpDate" />
    </w-table-cell>

    <w-table-cell :model="item.subjectHelp">
      <w-textarea :model="item.subjectHelp" />
    </w-table-cell>

    <w-table-cell :model="item.basicInformations">
      <w-textarea :model="item.basicInformations" />
    </w-table-cell>

    <w-table-cell :model="item.detailsInformations">
      <w-textarea :model="item.detailsInformations" />
    </w-table-cell>

    <w-table-cell :model="item.helpForm">
      <w-input :model="item.helpForm" />
    </w-table-cell>

    <w-table-cell :model="item.nominalHelp">
      <w-input :model="item.nominalHelp" />
    </w-table-cell>

    <w-table-cell :model="item.grossHelp">
      <w-input :model="item.grossHelp" />
    </w-table-cell>

    <w-table-cell :model="item.destinyHelp">
      <w-textarea :model="item.destinyHelp" />
    </w-table-cell>

    <td>
      <w-row-buttons :model="item" :move-up="index != 0" :move-down="item.$parent.$value.length - 1 !== index" />
    </td>
  </tr>
</template>

<script>
import components from '@witkac/bootstrap4-components';

// @vuese
// @De Minimis estimate row
// @Group detailsComponents
export default {
  components,
  props: {
    // Wartość przekazana do wypelnienia pola w schemacie
    item: { type: Object, required: true },

    // Indeks
    index: { type: Number, required: true }
  }
};
</script>
